<div class="question-container" [formGroup]="group" [ngClass]="{active: isSelected, interviewQuestion: interviewMode}" *ngIf="interviewMode || !hideQuestion(config)">
<div [ngClass]="isConfigInvalid()?'invalid-question':''">
    <div class="question-header" *ngIf="!interviewMode" (click)="selectQuestion()">
        <button type="button" class="btn btn-link float-start" (click)="expanded = !expanded">
            <i aria-hidden="true" class="fa" [ngClass]="{'fa-angle-right': !expanded, 'fa-angle-down': expanded}"></i>
        </button>
        <span class="question-mapkey">
            {{config.mapKeyName}}
        </span>
        <span class="question-mapkey float-end pe-2">
            {{config.answerTypeName}}
        </span>
    </div>
    <div class="question-body" *ngIf="expanded && config?.DisplayType && !useCondensedView">
        <div class="question-text rendered-quill-content ql-editor-updated" [innerHTML]="questionText"></div>
        <div class="help-text rendered-quill-content ql-editor-updated" [innerHTML]="helpText" *ngIf="config.helpText?.length"></div>
        <div class="question-form" [ngSwitch]="config?.DisplayType" *ngIf="showList">

            <div class="w-100" *ngSwitchCase="'button'" [attr.data-test-input-type]="inputTypeButton">
                <input type="hidden" [formControlName]="config.id">
                <mat-button-toggle-group class="flex flex-column" style="border: none;" hideSingleSelectionIndicator="true">
                <div *ngFor="let listValue of constantList" class="m-1">                    
                    <mat-button-toggle (click)="updateValueOnButtonClick(listValue.value)" [disabled]="isReadOnly()"  
                        [attr.data-test-value]="listValue.value"
                        style="text-transform:none">{{listValue.displayName}}
                    @if (group.get(config.id).value===listValue.value) {
                        <mat-icon style="margin-bottom: 6px; margin-left: 15px;">check</mat-icon>           
                    }             
                    </mat-button-toggle>
                </div>
                </mat-button-toggle-group>
            </div>

            <mat-radio-group *ngSwitchCase="'radio'" formControlName="{{config.id}}" [attr.data-test-input-type]="inputTypeRadiobutton">
                <mat-radio-button (focusin)="onFocus()" class="d-block" [disabled]="isReadOnly()" *ngFor="let listValue of constantList"
                    [value]="listValue.value" [attr.data-test-value]="listValue.value">{{listValue.displayName}}</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="group.get(config.id)?.hasError('required') && (group.get(config.id)?.dirty || group.get(config.id)?.touched)" class="error-text">required</mat-error>

            <!-- <mat-form-field *ngSwitchDefault class="w-100">
                <mat-select [placeholder]="config.Placeholder" (focusin)="onFocus()" formControlName="{{config.id}}" [disabled]="isReadOnly()">
                    <mat-option *ngFor="let listValue of config.listValues" [value]="listValue.value">{{listValue.displayName}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="group.get(config.id)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error> -->

            <auto-suggest *ngSwitchDefault disableSort="true" [list]="constantList" [placeholder]="config.Placeholder" field="displayName" dataKey="value"
                formControlName="{{config.id}}" (focusin)="onFocus()" [showRequiredError]="group.get(config.id)?.hasError('required') && (group.get(config.id)?.touched || group.get(config.id)?.dirty)"
                [disabled]="isReadOnly()"></auto-suggest>
            <mat-error *ngIf="group.get(config.id)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>

            <dynamic-form *ngIf="indentReflexiveQuestions && reflexiveQuestions?.length"  [expandAllQuestions]="true"
                [interviewMode]="'reflexive'" [parentId]="reflexiveFormId" [parentIndex]="formIndex"
                [constantLists]="constantLists" [ngClass]="{'nested-view-condensed': useCondensedStyle}"
                [config]="reflexiveQuestions"></dynamic-form>
        </div>
        <app-field-details [question]="config" [form]="group" [readOnlyMode]="isReadOnly()"></app-field-details>
    </div>
    <div class="condensed-view" *ngIf="expanded && config?.DisplayType && useCondensedView" [ngClass]="config.helpText?.length ? 'condensed-hint-view' : 'no-hint'">
        <div class="question-form" [ngSwitch]="config?.DisplayType" *ngIf="showList">
            <div class="w-100" *ngSwitchCase="'button'" [attr.data-test-input-type]="inputTypeButton" style="padding: 10px">
                <div class="question-text" [innerHTML]="questionText"></div>
                <div class="help-text rendered-quill-content " [innerHTML]="helpText" *ngIf="config.helpText?.length"></div>
                <input type="hidden" [formControlName]="config.id">
                <mat-button-toggle-group class="flex flex-column" style="border: none;" hideSingleSelectionIndicator="true">
                <div *ngFor="let listValue of constantList" class="m-1">                    
                    <mat-button-toggle (click)="updateValueOnButtonClick(listValue.value)" [disabled]="isReadOnly()"  
                        [attr.data-test-value]="listValue.value"
                        style="text-transform:none">{{listValue.displayName}}
                    @if (group.get(config.id).value===listValue.value) {
                        <mat-icon style="margin-bottom: 6px; margin-left: 15px;">check</mat-icon>           
                    }             
                    </mat-button-toggle>
                </div>
                </mat-button-toggle-group>
            </div>

            <div *ngSwitchCase="'radio'" style="padding-left: 16px;">
                <mat-label [innerHTML]="questionText" class="condensed-label-view"></mat-label>
                <mat-radio-group  formControlName="{{config.id}}" [attr.data-test-input-type]="inputTypeRadiobutton">
                    <mat-radio-button (focusin)="onFocus()" class="d-block" [disabled]="isReadOnly()" *ngFor="let listValue of constantList"
                        [value]="listValue.value" [attr.data-test-value]="listValue.value">{{listValue.displayName}}</mat-radio-button>
                </mat-radio-group>
                <mat-hint class="condensed-help-text" [innerHTML]="helpText"></mat-hint>
                <mat-error *ngIf="group.get(config.id)?.hasError('required') && (group.get(config.id)?.dirty || group.get(config.id)?.touched)" class="error-text">required</mat-error>                
            </div>

            <mat-form-field *ngSwitchDefault class="w-100">
                <mat-label [innerHTML]="questionText" class="condensed-label-view"></mat-label>
                <input type="text"
                    [disabled]="controlsDisabled"
                    [readonly]="controlsDisabled"
                    matInput
                    [formControlName]="config.id"
                    [matAutocomplete]="auto"
                    [matAutocompleteDisabled]="controlsDisabled">
                <mat-icon matSuffix style="cursor: pointer;">keyboard_arrow_down</mat-icon>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    @for (option of filteredOptions | async; track option) {
                        <mat-option [value]="option.value">{{option.displayName}}</mat-option>
                    }
                </mat-autocomplete>
                <mat-hint class="condensed-help-text" [innerHTML]="helpText"></mat-hint>
                <mat-error *ngIf="group.get(config.id)?.hasError('required')">required</mat-error>
            </mat-form-field>
            <dynamic-form *ngIf="indentReflexiveQuestions && reflexiveQuestions?.length"  [expandAllQuestions]="true" class="nested-view"
                [interviewMode]="'reflexive'" [parentId]="reflexiveFormId" [parentIndex]="formIndex"
                [constantLists]="constantLists"
                [config]="reflexiveQuestions"></dynamic-form>
        </div>
    </div>
  <interview-processing-status variant="question" [questionId]="config.id"></interview-processing-status>
</div>
</div>

<dynamic-form *ngIf="!indentReflexiveQuestions && reflexiveQuestions?.length"  [expandAllQuestions]="true" 
    [interviewMode]="'reflexive'" [parentId]="reflexiveFormId" [removeIndent]="true" [parentIndex]="formIndex"
    [constantLists]="constantLists"
    [config]="reflexiveQuestions"></dynamic-form>
